import React from 'react';
import type { FormField } from '../../../types/forms';

interface StatementFieldProps {
  field: FormField;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const StatementField: React.FC<StatementFieldProps> = ({ field }) => {
  return (
    <div className="py-4">
      <blockquote className="border-l-4 border-primary-500/50 pl-4">
        <p className="text-lg leading-relaxed" style={{ color: 'inherit' }}>{field.label}</p>
        {field.helpText && (
          <p className="text-sm mt-2" style={{ color: 'inherit', opacity: 0.6 }}>{field.helpText}</p>
        )}
      </blockquote>
    </div>
  );
};
